'use strict';

export default function messenger($rootScope, $timeout, $http, modal, Storage, userModel, utils, development, messengerModalTypes) {
  'ngInject';

  const STORAGE_KEY = 'sa_stm';
  const COUNT_STORAGE_KEY = 'sa_stm_c';
  const DAY = 24 * 60 * 60 * 1000;
  const DISTANT_FUTURE = 10 * 365 * DAY;
  const HIDE_INTERVALS = [
    DAY,
    7 * DAY,
    DISTANT_FUTURE,
  ];

  const storage = new Storage('cookie');

  function isExpired() {
    return !storage.get(STORAGE_KEY);
  }

  function hideTemporarily() {
    const hideCount = Number(storage.get(COUNT_STORAGE_KEY));
    const hideCountNext = Math.min(hideCount + 1, HIDE_INTERVALS.length);

    storage.set(COUNT_STORAGE_KEY, hideCountNext);
    storage.set(STORAGE_KEY, 1, { expires: new Date(Date.now() + HIDE_INTERVALS[hideCountNext - 1]) });
  }

  return {
    showModal() {
      if (development.disablePopUps()) {
        // Don't execute if development env (local_config setting)
        return;
      }

      const user = userModel.item;
      const prefs = user.preferences;

      if (isExpired() && user.id && prefs && (!prefs.fbMessengerId || prefs.isFbMessengerInvalid)) {
        hideTemporarily();

        const type = prefs.isFbMessengerInvalid ? messengerModalTypes.reconnect : messengerModalTypes.connect;

        return modal.open({
          template: `<sa-send-to-messenger-modal on-success="close()" type="${type}"></sa-send-to-messenger-modal>`,
        });
      }
    },

    hide() {
      storage.set(STORAGE_KEY, 1, { expires: new Date(Date.now() + DISTANT_FUTURE) });
      storage.remove(COUNT_STORAGE_KEY);
    },

    disconnect(userId) {
      return $http.post(utils.getApiUrl(`/settings/${userId}`), { fbMessengerId: null });
    },
  };
}



// WEBPACK FOOTER //
// ./app/src/services/messenger.js